<p-dialog [visible]="true" [draggable]="false" [appendTo]="'body'" [modal]="true">
  <ng-template pTemplate="header">{{'h5.boxCode' | translate}} {{case.bkCaseR}}</ng-template>
  <div class="dialog-body">
    <load-info-display [showUser]="false" [routeCurrent]="routeCurrent"></load-info-display>
    <form [formGroup]="formGroup">
      <span>
        <label for="caseType">{{'label.typeCase' | translate}}</label>
        <input class="input-left" id="caseType" formControlName="caseType">
        <p class="required-field" *ngIf="formGroup.controls.caseType.errors && formGroup.controls.caseType.errors.required">
			{{'modal.required' | translate }}
		</p>
      </span>
      <span>
        <label for="weight">{{'label.grossWeight' | translate}} (kg)</label>
        <input type="number" id="weight" formControlName="weight" pattern="^\d*(\.\d{0,3})?$">
        <p class="required-field" *ngIf="formGroup.controls.weight.errors && formGroup.controls.weight.errors.required">
			{{'modal.required' | translate }}
		</p>
      </span>
      <span>
        <label for="netWeight">{{'label.netWeight' | translate}} (kg)</label>
        <input type="number" id="netWeight" formControlName="netWeight" pattern="^\d*(\.\d{0,3})?$">
        <p class="required-field" *ngIf="formGroup.controls.netWeight.errors && formGroup.controls.netWeight.errors.required">
			{{'modal.required' | translate }}
		</p>
      </span>
      <span>
        <label for="height">{{'label.height' | translate}} (m)</label>
        <input type="number" id="height" formControlName="height" [step]=".001">
        <p class="required-field" *ngIf="formGroup.controls.height.errors && formGroup.controls.height.errors.required">
			{{'modal.required' | translate }}
		</p>
      </span>
      <span>
        <label for="width">{{'label.width' | translate}} (m)</label>
        <input type="number" id="width" formControlName="width" pattern="^\d*(\.\d{0,3})?$">
        <p class="required-field" *ngIf="formGroup.controls.width.errors && formGroup.controls.width.errors.required">
			{{'modal.required' | translate }}
		</p>
      </span>
      <span>
        <label for="depth">{{'label.depth' | translate}} (m)</label>
        <input type="number" id="depth" formControlName="depth" pattern="^\d*(\.\d{0,3})?$">
        <p class="required-field" *ngIf="formGroup.controls.depth.errors && formGroup.controls.depth.errors.required">
			{{'modal.required' | translate }}
		</p>
      </span>
    </form>

    <!-- <ng-container *ngIf="newCase">
      <div class="new-case-info">
        <p class="bold">Nova case: {{newCase.bkCaseTypeC}}</p>
        <div class="measures">
          <i class="pi pi-plus" (click)="setNewBoxInfo()"></i>
          <p>Peso da caixa: <span class="bold">{{newCase.weigthQ}}kg</span></p>
          <p>Largura da caixa: <span class="bold">{{newCase.widthQ}}m</span></p>
          <p>Altura da caixa <span class="bold">{{newCase.heightQ}}m</span></p>
          <p>Profundidade da caixa <span class="bold">{{newCase.depthQ}}m</span></p>
        </div>
      </div>
    </ng-container> -->
  </div>
  <ng-template pTemplate="footer">
    <ng-container *ngIf="formGroup && formGroup.controls">
      <ng-container *ngIf="!formGroup.valid">
        <p class="form-error-message">{{'modal.invalidData' | translate}}</p>
      </ng-container>
      <ng-container *ngIf="formGroup.controls.caseType.errors && formGroup.controls.caseType.errors.notFound">
        <p class="form-error-message">{{formGroup.controls.caseType.errors.notFound}}</p>
      </ng-container>
      <ng-container *ngIf="formGroup.controls.netWeight.errors && formGroup.controls.grossWeightLessThanNetWeight.errors.netWeightGreaterThanGrossWeight">
        <p class="form-error-message">{{'modal.netWeightGreaterThanGrossWeight' | translate }}</p>
      </ng-container>
      <ng-container *ngIf="formGroup.controls.weight.errors && formGroup.controls.weight.errors.grossWeightLessThanNetWeight">
        <p class="form-error-message">{{'modal.grossWeightLessThanNetWeight' | translate }}</p>
      </ng-container>
      <ng-container *ngIf="minimumValueStillRequired">
        <p class="form-error-message">{{'modal.quantityLessOrEqualToZero' | translate}}</p>
      </ng-container>
    </ng-container>

    <span>
      <button (click)="closeModal()" id="confirmCaseInfoEdition" type="button" pButton label="{{'modal.cancel' | translate}}" class="cancel-button"></button>
      <button id="closeCaseInfoEdition" (click)="saveNewBoxInfo()" pButton label="{{'modal.confirm' | translate}}" [disabled]="!formGroup.valid" class="confirm-button"></button>
    </span>
  </ng-template>
</p-dialog>
